<template>
  <div>
    <p class="mb-3">
      The total number of electrons that can occupy a set of
      <stemble-latex :content="orbType" />
      is:
    </p>

    <v-form @submit.prevent="submitResponse">
      <v-radio-group v-model="inputs.input1" :disabled="!allowEditing">
        <v-radio
          v-for="option in options1"
          :key="option.value"
          class="d-inline-block"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.expression" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';

export default {
  name: 'Question200d',
  components: {
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
      options1: [
        {expression: '$2$', value: '2'},
        {expression: '$6$', value: '6'},
        {expression: '$10$', value: '10'},
        {expression: '$12$', value: '12'},
        {expression: '$14$', value: '14'},
      ],
    };
  },
  computed: {
    versionVariable() {
      return this.taskState.getValueBySymbol('versionVariable').content;
    },
    orbType() {
      if (this.versionVariable.value === 1) {
        return '$\\textbf{d-orbitals}$';
      } else if (this.versionVariable.value === 2) {
        return '$\\textbf{f-orbitals}$';
      } else {
        return '';
      }
    },
  },
};
</script>
